import React from 'react'
import { Stack, Switch, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { setPriceIvaMode } from '../../store/slices/contextUI'
import { ivaPriceSwitchSx } from '../../constants/ivaPriceSwitchSx'

/** sin IVA (off) por defecto; con IVA cuando switch activado */
export default function IvaPriceSwitch({ compact = false, onDark = false, sx }) {
  const dispatch = useDispatch()
  const priceWithIva = useSelector((state) => state.contextUI.PriceIVA)

  const labelMuted = onDark ? 'rgba(255,255,255,0.55)' : '#9ca3af'
  const labelActive = onDark ? '#ffffff' : '#176318'
  const labelInactive = onDark ? 'rgba(255,255,255,0.7)' : '#6b7280'
  const prefixMuted = onDark ? 'rgba(255,255,255,0.55)' : '#9ca3af'

  return (
    <Stack
      direction="row"
      alignItems="center"
      flexWrap="nowrap"
      spacing={compact ? 0.75 : 1}
      sx={{
        userSelect: 'none',
        ...sx,
      }}
    >
      {!compact && (
        <Typography variant="body2" sx={{ color: prefixMuted, whiteSpace: 'nowrap' }}>
          Los precios
        </Typography>
      )}

      <Typography
        variant="body2"
        component="span"
        sx={{
          fontWeight: !priceWithIva ? 700 : 500,
          color: !priceWithIva ? labelActive : labelInactive,
          whiteSpace: 'nowrap',
          transition: 'color 0.2s ease',
        }}
      >
        sin IVA
      </Typography>

      <Switch
        checked={priceWithIva}
        onChange={() => dispatch(setPriceIvaMode(!priceWithIva))}
        sx={ivaPriceSwitchSx}
        inputProps={{ 'aria-label': 'Mostrar precios con IVA' }}
      />

      <Typography
        variant="body2"
        component="span"
        sx={{
          fontWeight: priceWithIva ? 700 : 500,
          color: priceWithIva ? labelActive : labelMuted,
          whiteSpace: 'nowrap',
          transition: 'color 0.2s ease',
        }}
      >
        con IVA
      </Typography>
    </Stack>
  )
}
